export default __webpack_public_path__ + "static/media/cart-icon.8a8d9bb9.svg";